import z from "zod";

export const zCatalogTreeItem = z.object({
  id: z.string().optional(),
  name: z.string(),
  hasChildren: z.boolean(),
  childrenCount: z.number(),
  cardCount: z.number(),
});

export type ZCatalogTreeItem = z.infer<typeof zCatalogTreeItem>;
